import { getCore } from '../../../client/core/getCore';
import type { DynamicClient } from '../../../client/types';
import type { SessionKeys } from '../sessionKeys.types';

/** @notInstrumented */
export const getSessionKeys = (client: DynamicClient): SessionKeys | undefined => {
  const core = getCore(client);

  const publicKey = core.state.get().sessionKeys;

  if (!publicKey) {
    return undefined;
  }

  return { publicKey };
};
